export default
    {
        // 疫情退改申请
        async yqRefundApply(params) {
            let actiontype = 'refundApply';
            return await this.fetch(actiontype, params);
        },
        // 疫情退改申请列表
        async yqGetRefundApplyList(params) {
            let actiontype = 'getRefundApplyList';
            return await this.fetch(actiontype, params);
        },
        // 旅客信息收集
        async passengerArrivalInfoAdd(params) {
            let actiontype = 'passengerArrivalInfoAdd';
            return await this.fetch(actiontype, params);
        },
        // 获取省市区枚举值
        async getDataItemByOptName(params) {
            let actiontype = 'getDataItemByOptName';
            return await this.fetch(actiontype, params);
        },
        // 取消申请
        async changeRefundStatus(params) {
            let actiontype = 'cancelRefundApply';
            return await this.fetch(actiontype, params); 
        }
    }


// WEBPACK FOOTER //
// ./src/interfaces/modules/apply.js